import React from 'react';
import styles from './More.module.css';
const MorePage = () => {


    return (
        <>
        <h1>More</h1>
        </>
    )
}

export default MorePage;

